import { faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import VoxelIconButton from '../../components/voxel/Buttons/VoxelIconButton';
import VoxelPanel from '../../components/voxel/Surfaces/VoxelPanel';
import VoxelTable from '../../components/voxel/Tables/VoxelTable';
import VoxelTableCell from '../../components/voxel/Tables/VoxelTableCell';
import VoxelText from '../../components/voxel/Text/VoxelText';
import { CurrentUserGq } from '../../graphql/users/models/CurrentUserGq';
import { projectsApiService } from '../../graphql/projects/projectsApiService';


export interface NotificationsPageProps {
  user: CurrentUserGq;
  reload: () => void;
}

const NotificationsPage: React.FC<NotificationsPageProps> = ({
  user,
  reload
}) => {
  // Get subscribed projects
  const projectQuery = projectsApiService.queries.useGetProjects(
    {
      ids: user?.projectSubscriptions,
      sortBy: 'createTime',
      sortDirection: 'asc',
    },
    { skip: !user || !user.projectSubscriptions.length }
  );
  const subscriptionMutation = projectsApiService.mutations.projects.useSubscribeToProject();
  const [unsubscribedIds, setUnsubscribedIds] = useState<number[]>([]);
  const handleUnsubscribe = (projectId: number) => {
    setUnsubscribedIds((prev) => [...prev, projectId]);
    subscriptionMutation({ projectId: projectId, on: false }).then(() => reload());
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="py-4">
        <VoxelText variant="title2">Email notifications</VoxelText>
        <VoxelText variant="bread-normal" paddingTop>
          You'll receive email notifications when these projects have new data
        </VoxelText>
      </div>
      {!user?.projectSubscriptions?.length && <VoxelText>None</VoxelText>}
      {!!user?.projectSubscriptions.length && (
        <VoxelPanel className="w-full">
          <VoxelTable>
            <tbody className="divide-solid divide-y divide-gray-100">
              {user?.projectSubscriptions.map((projectId) => {
                if (unsubscribedIds.includes(projectId)) return null;
                const project = projectQuery.data?.projects?.find((p) => p.id === projectId);
                if (!project) return null;

                return (
                  <tr key={projectId}>
                    <VoxelTableCell className="truncate text-ellipsis">
                      {project.name}
                    </VoxelTableCell>
                    <VoxelTableCell align='right'>
                      <VoxelIconButton
                        icon={<FontAwesomeIcon icon={faTrash} />}
                        tooltip={'Unsubscribe'}
                        onClick={() => handleUnsubscribe(projectId)}
                      />
                    </VoxelTableCell>
                  </tr>
                );
              })}
            </tbody>
          </VoxelTable>
        </VoxelPanel>
      )}
    </div>
  );
};

export default NotificationsPage;
